export default __webpack_public_path__ + "static/media/Iscreen_placeholder.dd81eadc.png";